import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { safeParse } from '../calendarDateUtils';

interface EventMetaFooterProps {
  createdAt?: string | null;
  updatedAt?: string | null;
}

const tryDistance = (iso?: string | null): string | null => {
  if (!iso) return null;
  try {
    return formatDistanceToNow(safeParse(iso), { addSuffix: true });
  } catch {
    return null;
  }
};

const EventMetaFooter: React.FC<EventMetaFooterProps> = ({ createdAt, updatedAt }) => {
  const created = tryDistance(createdAt);
  const updated = tryDistance(updatedAt);
  if (!created && !updated) return null;
  return (
    <p className="text-[11px] text-text-tertiary pt-2 border-t border-border-primary/10">
      {created && <span>Created {created}</span>}
      {created && updated && <span> · </span>}
      {updated && <span>Updated {updated}</span>}
    </p>
  );
};

export default EventMetaFooter;
